import React from "react";
import { Box } from "@mui/material";
import UserPredictionTable from "../../components/UserPredictionTable";

const AllUsersPredictionPage = () => {
  // Prevent page scrolling
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <Box sx={{ height: '100vh', overflow: 'hidden' }}>
      <UserPredictionTable />
    </Box>
  );
};

export default AllUsersPredictionPage;
